import type { GetStaticPaths } from 'next'

export { default, getStaticProps } from '../../[bid]'

// Deeper catalog pages keep the same ISR cache as the first page.
export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [],
  fallback: process.env.BUILD ? false : 'blocking',
})
